import { createFeature } from '@ngrx/store';
import { userSettingsReducer } from './user-settings-reducer';

export const userSettingsFeature = createFeature({
  name: 'userSettings',
  reducer: userSettingsReducer
});
